import $ from 'jquery';
import init from "../init";
import {dependency} from "../utils/request";
import {onResize, onScroll} from "../utils/window";

export default function homepage() {
	const $html = $('html');
	const $scroller = $('html, body');
	const checkout = $('.checkout');
	const customerForm = checkout.find('#form-customer'),
		addressForm = checkout.find('#form-address'),
		shippingForm = checkout.find('#form-shipping'),
		payForm = checkout.find('#form-payment'),
		addresses = checkout.find('[data-countries]').data('countries'),
		states = checkout.find('[data-states]').data('states'),
		fieldToResize = checkout.find('.checkout-order[sw-sticky]');

	const actionUrl = checkout.find('.checkout-wrapper').data('action');
	polyFills();
	setupCountry(addresses, states, addressForm);
	setupSameAddressToggle();

	// SUBMIT EVENTS
	customerForm.submit(function (e) {
		e.preventDefault();

		const form = $(this);

		updateCommerce(actionUrl, form.serialize(), {
			form: addressForm,
			prev: customerForm,
			addresses: addresses,
			states: states
		});
	});

	addressForm.submit(function (e) {
		e.preventDefault();

		const form = $(this);
		let stateSelect = form.find('select[name="shippingAddress[stateValue]"]');
		let stateInput = form.find('input[name="shippingAddress[stateValue]"]');
		let isRemoved = false;

		if (stateSelect.val()) {
			stateInput.removeAttr('name');
			isRemoved = true;
		}

		let data = form.serialize();

		if (isRemoved) {
			stateInput.attr('name', 'shippingAddress[stateValue]');
		}

		updateCommerce(actionUrl, data, {
			form: shippingForm,
			prev: addressForm,
			addresses: false,
			states: false
		});
	});

	shippingForm.submit(function (e) {
		e.preventDefault();

		const form = $(this);

		updateCommerce(actionUrl, form.serialize(), {
			form: payForm,
			prev: shippingForm,
			addresses: false,
			states: false
		});
	});

	// initShipping(actionUrl, shippingForm);

	// sticky order details
	updateOrderSummarySize(fieldToResize);

	onResize(function () {
		updateOrderSummarySize(fieldToResize);
	});

	onScroll(setupScroll);
}

function initShipping(actionUrl, shippingForm) {
	// const currentButton = shippingForm.find('.checkout-next_button');

	if (!shippingForm.find('.checkout-fields-main').is(':empty')) {
		$('[name=shippingMethodHandle]').change(function (e) {
			// currentButton.click();
			updateShippingSection(actionUrl, shippingForm);
		});
	}
}

function setupScroll() {
	const $key = $('.checkout-order');
	const $container = $('.checkout-sections');

	if ($key.length) {
		let $containerOffset = $container.offset().top + $container.outerHeight();
		let $keyOffset = $key.offset().top + $key.outerHeight();

		if ($key.hasClass('-stop')) {
			if ($(document).scrollTop() < $key.offset().top) {
				$key.removeClass('-stop');
			}
		} else {
			if (($keyOffset - 50) > $containerOffset) {
				$key.addClass('-stop');
			}
		}
	}
}

function updateOrderSummarySize(field) {
	if (field.length) {
		field.css('width', '');

		if (!field.hasClass('is-stuck')) {
			field.css('width', field.outerWidth() + 'px');
		} else {
			field.css('width', $('[sw-sticky-filler]').outerWidth() + 'px');
		}
	}
}

function updateShippingSection(url, form) {
	$.ajax({
			type: 'post',
			dataType: 'json',
			url: url,
			data: form.serialize(),
			success: function (response) {
				if (response && response.success) {
					refreshOrderSummary();
				}
			},
			error: function (response) {
				alert('An error has occurred, please try again later');
			}
		});
}

function updateCommerce(url, data, nextForm) {
	$.ajax({
		type: 'post',
		dataType: 'json',
		url: url,
		data: data,
		success: function (response) {
			if (response && response.success) {
				let form = nextForm.form;
				let formWrapper = nextForm.form.closest('.checkout-section');
				let button = nextForm.prev.find('.checkout-next_button');

				if (form.data('url')) {
					$.get(form.data('url')).done(function (data) {
						formWrapper.find('.checkout-fields-main').html(data);
						init(formWrapper);
						formWrapper.removeClass('-disabled');

						if (nextForm.addresses && nextForm.states) {
							setupCountry(nextForm.addresses, nextForm.states, form);
							setupSameAddressToggle();
						}

						if (form.attr('id') === 'form-shipping' && !form.find('.checkout-shipping-input').hasClass('-no-shipping')) {
							form.closest('.checkout-section').removeClass('-no-shipping');
							// const currentButton = form.find('.checkout-next_button');

							// $('[name=shippingMethodHandle]').change(function (e) {
							// 	// currentButton.click();
							// 	initShipping();
							// });
						}

						if (form.attr('id') === 'form-payment') {
							refreshOrderSummary();
							setupPayment(form);
						}

						button.html('Update');
					});
				} else {
					formWrapper.removeClass('-disabled');
					button.html('Update');
				}
			}
		},
		error: function (response) {
			alert('An error has occurred, please try again later');
		}
	});
}

function setupSameAddressToggle() {
	let toggle = $('#billingAddressSameAsShipping');

	if (toggle.length) {
		let billingContainer = $('.checkout-billingAddress');
		toggle.on('change', function (e) {
			if (!toggle.prop('checked')) {
				billingContainer.removeClass('is-hidden');
			} else {
				billingContainer.addClass('is-hidden');
			}
		});
	}
}

function refreshOrderSummary() {
	const summary = $('.checkout-order');
	const action = summary.data('action');
	const container = summary.find('.checkout-order-info');

	$.get(action).done(function (data) {
		container.html(data);
	});
}

function setupEmptyOption(field, defaultValue) {
	let emptyOption = null;
	if (defaultValue) {
		emptyOption = new Option('', '', false, false);
	} else {
		emptyOption = new Option('', '', false, true);
	}
	field.append(emptyOption);
}

function setupCountry(addresses, states, form) {
	const fields = form.find('[name="shippingAddress[countryId]"], [name="billingAddress[countryId]"]');
	let defaultValue = null;

	if (fields.length) {
		fields.each(function () {
			let field = $(this);
			let wrapper = field.closest('.checkout-fields-input');
			let name = wrapper.data('address');

			defaultValue = field.val();
			field.html('');
			setupEmptyOption(field, defaultValue);

			for (let [key, value] of Object.entries(addresses)) {
				let option = new Option(value, key, false, (parseInt(key) === parseInt(defaultValue)));
				field.append(option);
			}

			field.change(function () {
				let selected = field.val();
				setupStates(selected, states, form, name);
			});

			if (defaultValue) {
				setupStates(defaultValue, states, form, name);
			}
		})
	}
}

function setupStates(selected, states, form, name) {
	const field = form.find(`select[name="${name}[stateValue]"]`);
	const fieldAlt = form.find(`input[name="${name}[stateValue]"]`);

	let defaultValue = null;

	if (field.length) {
		const fieldContainer = field.closest('.checkout-fields-input');
		const fieldAltContainer = fieldAlt.closest('.checkout-fields-input');

		defaultValue = field.val();

		let country = states[selected];

		if (country && Object.keys(country).length) {
			fieldContainer.removeClass('-hidden');
			fieldAltContainer.addClass('-hidden');

			field.html('');

			setupEmptyOption(field, defaultValue);
			for (let [key, value] of Object.entries(country)) {
				let option = new Option(value, key, false, (parseInt(key) === parseInt(defaultValue)));
				field.append(option);
			}
		} else {
			fieldContainer.addClass('-hidden');
			fieldAltContainer.removeClass('-hidden');
		}
	}
}

function polyFills() {
	// polyfill
	if (!Object.entries) {
		Object.entries = function (obj) {
			var ownProps = Object.keys(obj),
				i = ownProps.length,
				resArray = new Array(i); // preallocate the Array
			while (i--)
				resArray[i] = [ownProps[i], obj[ownProps[i]]];

			return resArray;
		};
	}
}

function setupPayment(form) {
	if (document.querySelector('[name=stripePublishableKey]')) {
		const publishableKey = document.querySelector('[name=stripePublishableKey]').value;
		if (publishableKey) {
			dependency('https://js.stripe.com/v3/', () => Stripe && window.Stripe).then(function () {
				const btn = $('.checkout-complete');
				setupStripe(publishableKey, form);
				btn.removeClass('is-hidden');
				btn.click(function (e) {
					e.preventDefault();
					form.submit();
				});
			});
		}
	}
}

function setupStripe(publishableKey, form) {
	const stripe = Stripe(publishableKey);

	const elements = stripe.elements({
		fonts: [
			{
				cssSrc: 'https://use.typekit.net/jnv8mht.css'
			}
		]
	});

	const tempEl = document.querySelector('[name="shippingAddress[firstName]"]');
	const inputStyle = getComputedStyle(tempEl);

	const style = {
		base: {
			fontSize: '18px',
			fontFamily: inputStyle.getPropertyValue('font-family'),
			fontWeight: inputStyle.getPropertyValue('font-weight'),
			lineHeight: inputStyle.getPropertyValue('line-height'),
			color: inputStyle.getPropertyValue('color'),
			'::placeholder': {
				color: 'transparent'
			}
		},
		invalid: {
			color: '#ff4132'
		},
		complete: {
			color: '#3d9a82'
		}
	};

	const classes = {
		base: 'StripeElement',
		complete: 'StripeElement--complete',
		empty: 'StripeElement--empty',
		focus: 'StripeElement--focus',
		invalid: 'StripeElement--invalid',
		webkitAutoFill: 'StripeElement--webkit-autofill'
	};

	const card = elements.create('cardNumber', {classes, style});
	card.mount('#card-number');

	const expiry = elements.create('cardExpiry', {classes, style});
	expiry.mount('#card-expiry');

	const cvc = elements.create('cardCvc', {classes, style});
	cvc.mount('#card-cvc');

	card.addEventListener('change', cardError);
	expiry.addEventListener('change', cardError);
	cvc.addEventListener('change', cardError);

	form.submit(function (e) {
		e.preventDefault();

		let billingDetails = {
			address: {
				city: $('[name="shippingAddress[city]"]').val(),
				line1: $('[name="shippingAddress[address1]"]').val(),
				line2: $('[name="shippingAddress[address2]"]').val(),
				postal_code: $('[name="shippingAddress[zipCode]"]').val(),
				state: $('[name="shippingAddress[stateValue]"]').val()
			},
			email: $('[name="orderEmail"]').val(),
			name: $('[name="shippingAddress[firstName]"]').val() + ' ' + $('[name="shippingAddress[lastName]"]').val(),
			phone: $('[name="shippingAddress[phone]"]').val()
		};
		// pk_live_51GxO7NJle4tD1NrGqTKdjeb5YYsVuVEzpquaTjW6ha7kKFKYeWqTBf61qWXUHIaEDk8tnOwjFM7mtaFsr1AT8c8m00w34W4dvH
		// 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
		stripe.createPaymentMethod({
			type: 'card',
			card: card,
			billing_details: billingDetails
		}).then(result => {
			if (result.error) {
				cardError(result)
			} else {
				const hiddenInput = `<input type="hidden" name="paymentMethodId" value="${result.paymentMethod.id}">`;

				form.append(hiddenInput);
				form.off('submit');
				form.submit();
			}
		});
	});
}

function cardErrors(event) {
	cardError(event.error.message);
}

function cardError(event) {
	const displayError = document.getElementById('form-error');
	displayError.textContent = event.error && event.error.message || '';

	if (displayError.textContent) {
		displayError.classList.add('-show');
	} else {
		displayError.classList.remove('-show');
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/checkout.js